import { z } from "zod";

const apiErrorEnvelopeSchema = z.object({
  error: z.object({
    code: z.string().min(1),
    message: z.string().min(1),
    correlation_id: z.string().nullable(),
    fields: z.record(z.string(), z.array(z.string())),
  }),
});

export interface ApiError {
  readonly code: string;
  readonly message: string;
  readonly correlationId: string | null;
  readonly fieldErrors: Readonly<Record<string, readonly string[]>>;
}

const unknownApiError: ApiError = {
  code: "UNKNOWN_API_ERROR",
  message: "Não foi possível concluir a solicitação.",
  correlationId: null,
  fieldErrors: {},
};

const networkError: ApiError = {
  code: "NETWORK_ERROR",
  message: "Não foi possível conectar à API.",
  correlationId: null,
  fieldErrors: {},
};

export function normalizeApiError(input: unknown): ApiError {
  if (input instanceof TypeError) {
    return { ...networkError, fieldErrors: {} };
  }

  const parsed = apiErrorEnvelopeSchema.safeParse(input);
  if (!parsed.success) {
    return { ...unknownApiError, fieldErrors: {} };
  }

  const { error } = parsed.data;

  return {
    code: error.code,
    message: error.message,
    correlationId: error.correlation_id,
    fieldErrors: Object.fromEntries(
      Object.entries(error.fields).map(([field, messages]) => [field, [...messages]]),
    ),
  };
}
